var _style, _rect, _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFortuna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.3 132.3",
    style: {
      enableBackground: "new 0 0 132.3 132.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDD00;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_20_",
    x: 0,
    y: 0,
    className: "st0",
    width: 132.3,
    height: 132.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st1",
    d: "M108.8,53.9c0,23.7-19.1,42.9-42.7,42.9S23.4,77.6,23.4,53.9S42.5,11,66.1,11 C89.7,11,108.8,30.2,108.8,53.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M88.5,54.1c0,12.3-9.9,22.3-22.2,22.3s-22.2-10-22.2-22.3S54,31.8,66.3,31.8C78.6,31.8,88.5,41.8,88.5,54.1  M108.8,53.9c0-23.7-19.1-42.9-42.7-42.9S23.4,30.2,23.4,53.9s19.1,42.9,42.7,42.9C89.7,96.8,108.8,77.6,108.8,53.9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    points: "10.9,121.4 10.9,107.8 21.7,107.8 21.7,111.2 14.4,111.2 14.4,113 20,113 20,116.4 14.4,116.4  14.4,121.4 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M44.4,121.4v-13.6h7.2c2.5,0,4.6,1.8,4.6,4.6c0,1.9-1.2,3.6-2.7,4.1c0.3,0.6,2.6,4.5,2.9,5h-4.3 c-0.2-0.4-2.2-4-2.5-4.5h-1.8v4.5h-3.4V121.4z M47.8,113.6h3.5c0.7,0,1.4-0.4,1.4-1.2c0-0.8-0.6-1.2-1.4-1.2h-3.5V113.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    points: "63.6,121.4 63.6,111.2 60.3,111.2 60.3,107.8 70.4,107.8 70.4,111.2 67.1,111.2 67.1,121.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M75.5,107.8H79v8.7c0,0.9,0.7,1.8,1.9,1.8c1,0,1.9-0.8,1.9-1.8v-8.7h3.4v8.4c0,3.1-2.3,5.4-5.3,5.4 s-5.3-2.3-5.3-5.4v-8.4H75.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M92.7,121.4v-13.9c0.5,0.5,6.8,6.1,7.4,6.7v-6.4h3.4v13.9c-0.7-0.6-6.8-6.2-7.4-6.7v6.4H92.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M111.7,121.4H108c0.1-0.3,4.8-13.4,4.9-13.6h3.5c0.1,0.2,5,13.3,5.1,13.6h-3.7c-0.1-0.3-0.8-2.1-0.8-2.3h-4.5 C112.4,119.3,111.8,121.2,111.7,121.4 M114.7,112.9c-0.1,0.2-0.9,2.7-1,2.9h2.1C115.7,115.6,114.7,113.1,114.7,112.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M39.6,114.5c0,4-3.2,7.2-7.2,7.2s-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2S39.6,110.6,39.6,114.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M36.2,114.6c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7 C34.5,110.8,36.2,112.5,36.2,114.6 M39.6,114.5c0-4-3.2-7.2-7.2-7.2s-7.2,3.2-7.2,7.2s3.2,7.2,7.2,7.2S39.6,118.5,39.6,114.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFortuna);
export default __webpack_public_path__ + "static/media/logo_fortuna.a388365d11a43afead15a15b753972cf.svg";
export { ForwardRef as ReactComponent };